/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditcostadminfree3Inputs */

const en_creditcostadminfree3 = /** @type {(inputs: Creditcostadminfree3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free for admins`)
};

const de_creditcostadminfree3 = /** @type {(inputs: Creditcostadminfree3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Admin kostenlos`)
};

/**
* | output |
* | --- |
* | "Free for admins" |
*
* @param {Creditcostadminfree3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditcostadminfree3 = /** @type {((inputs?: Creditcostadminfree3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditcostadminfree3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditcostadminfree3(inputs)
	return de_creditcostadminfree3(inputs)
});
export { creditcostadminfree3 as "creditCostAdminFree" }